import { normalizeLedgerFields } from "./ledger-field-compat";
import type { Owner } from "../types";
import type { ReceiptDraft } from "../types/receipt";

// A scan in progress, kept on the device. Scanning a receipt is several steps — read it, correct
// the items, save it, then optionally record prices — and a phone can lose the tab at any of them,
// so the draft is written down rather than held in memory.

export const receiptKey = (profile: Owner) => `barnyard-receipt-${profile}`;

export type ReceiptState = {
  draft: ReceiptDraft;
  step: "details" | "items" | "tracking";
  pending: boolean;
  updated: number;
  trackingItemIds?: string[];
  remainingDrafts?: ReceiptDraft[];
  receiptNumber?: number;
  receiptTotal?: number;
  savedAccountIds?: string[];
};

export function restoreReceipt(profile: Owner): ReceiptState | null {
  try {
    const s = normalizeLedgerFields(JSON.parse(localStorage.getItem(receiptKey(profile)) || "null"));
    return s &&
      s.draft?.items &&
      (s.pending || s.step === "tracking" || Date.now() - s.updated < 86400000)
      ? s
      : null;
  } catch {
    return null;
  }
}
